
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.584 5.907l9.998 10.002v.189l-9.998 9.997h-.188a2.584 2.584 0 010-3.653l6.442-6.443-6.442-6.443a2.58 2.58 0 010-3.65h.188zm15.613.623l.153.109v18.45l-.153.108h-2.361l-.153-.109V6.638l.153-.108h2.361z","fill":"#0072C8","fill-rule":"evenodd"}})])
          )
        }
      }
    